import React from 'react';
import styles from './ClientSongFromSpotifyForm.module.css';
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from 'formik';
import * as yup from 'yup';
import Button from '../../../../ui/Buttons/Button/Button';
import FormField from '../../../../ui/DataEntry/FormField/FormField';
import Label from '../../../../ui/DataEntry/Label/Label';

export type ClientSongFromSpotifyFormProps = {
    handleSubmit: (values: SongFromSpotifyFormValues, helpers: FormikHelpers<SongFromSpotifyFormValues>) => void;
};

type SongFromSpotifyFormValues = {
    url: string;
};

const validationSchema = yup.object({
    url: yup.string().required().url('Enter valid url'),
});

const ClientSongFromSpotifyForm = ({ handleSubmit }: ClientSongFromSpotifyFormProps) => {
    return (
        <Formik
            enableReinitialize
            initialValues={{
                url: '',
            }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
        >
            {({ submitForm, isSubmitting, isValid }) => (
                <>
                    <Form>
                        <FormField>
                            <Label htmlFor="url">Spotify URL</Label>
                            <Field id="url" name="url" placeholder="Enter Spotify URL" />
                            <ErrorMessage name="url">
                                {(msg) => <span className={styles.error}>{msg}</span>}
                            </ErrorMessage>
                        </FormField>
                    </Form>
                    <Button
                        className={styles.submitButton}
                        type="filled"
                        color="black"
                        onClick={submitForm}
                        loading={isSubmitting}
                        disabled={!isValid}
                    >
                        Submit
                    </Button>
                </>
            )}
        </Formik>
    );
};

export default ClientSongFromSpotifyForm;
